import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = { title: String, prestations: Array };

  open(event) {
    event.preventDefault();
    event.stopPropagation();

    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <form class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"></h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label">Filtrer par prestations</label>
              <select multiple></select>
              <small class="form-text text-muted">Laisser vide pour inclure toutes les prestations.</small>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
              <button type="submit" class="btn btn-primary">Générer le PDF</button>
            </div>
          </form>
        </div>
      </div>
    `;
    wrap.querySelector(".modal-title").textContent = this.titleValue;

    const select = wrap.querySelector("select");
    this.prestationsValue.forEach(({ id, description }) => {
      select.add(new Option(description, id));
    });

    document.body.append(wrap);
    const modalElement = wrap.querySelector(".modal");
    const modal = new Modal(modalElement);
    let slim = null;

    modalElement.addEventListener("shown.bs.modal", () => {
      if (typeof SlimSelect === "undefined") return;
      slim = new SlimSelect({
        select,
        settings: {
          placeholderText: "Toutes les prestations",
          searchPlaceholder: "Rechercher...",
          searchText: "Pas de résultats",
          contentLocation: modalElement,
        },
      });
    });

    modalElement.addEventListener("hidden.bs.modal", () => {
      if (slim) slim.destroy();
      modal.dispose();
      wrap.remove();
    });

    wrap.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      window.open(this.buildUrl(select), "_blank", "noopener");
      modal.hide();
    });

    modal.show();
  }

  buildUrl(select) {
    const url = new URL(this.element.href, window.location.origin);
    url.searchParams.delete("prestation_ids[]");
    Array.from(select.selectedOptions).forEach((option) => {
      url.searchParams.append("prestation_ids[]", option.value);
    });
    return url.toString();
  }
}
